// One comment. The body is rendered as a text node, so markup someone typed shows as typed and is
// never run (constitution §6.10, qa Q23).
import { formatLocal } from '@cis/shared';
import type { Comment } from '@cis/api-client';
import { useDeleteComment } from '../../api/comments.ts';
import { userMessage } from '../../ui/error-message.ts';
import { useToast } from '../../ui/toast.tsx';

export function CommentItem(props: {
  readonly taskId: string;
  readonly comment: Comment;
}): React.JSX.Element {
  const { comment } = props;
  const remove = useDeleteComment(props.taskId);
  const toast = useToast();
  const onDelete = (): void => {
    remove.mutate(comment.id, {
      onSuccess: () => toast.show('success', 'Comment deleted. It stays in the history.'),
      onError: (err) => toast.show('error', userMessage(err)),
    });
  };
  return (
    <li className="comment">
      <div className="comment__meta">
        <span className="comment__author">{comment.author.displayName}</span>
        <time className="comment__time" dateTime={comment.createdAt}>
          {formatLocal(comment.createdAt)}
        </time>
      </div>
      <p className="comment__body">{comment.body}</p>
      {comment.canDelete ? (
        <button
          type="button"
          className="btn btn--secondary comment__delete"
          aria-label={`Delete comment by ${comment.author.displayName}`}
          disabled={remove.isPending}
          onClick={onDelete}
        >
          {remove.isPending ? 'Deleting…' : 'Delete'}
        </button>
      ) : null}
    </li>
  );
}
